import { createApi } from '@reduxjs/toolkit/query/react'
import { playerBaseQuery } from './playerBaseQuery'

export const configApi = createApi({
	reducerPath: 'configApi',
	baseQuery: playerBaseQuery,
	endpoints: () => ({}),
})
